import { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { Box, Card, CardHeader, IconButton, Stack } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate, useParams } from "react-router-dom";
import { fetchDataById, putData } from "../../../api/Services";
import { ArrowBack } from "@mui/icons-material";
import { MotorRTOForm } from "./components/motorRTOForm";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";

const EditMotorRTO = () => {

  const navigate = useNavigate();
  const { setCircleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();
  const params = useParams();
  const paramId = params?.id;

  const [rtoData, setRTOData] = useState({});


  useEffect(() => {
    const fetchData = async () => {
      if (paramId) {
        setCircleLoading(true);
        try {
          await fetchDataById(`/reference/motor/RTO/${paramId}`).then(
            (res) => {
              const responseData = res?.data;
              setRTOData((prevData) => ({
                ...prevData,
                name: responseData?.name,
                displayName: responseData?.displayName,
                rtoCode: responseData?.rtocode,
                state: {
                  label: responseData?.city?.district?.state?.name,
                  value: responseData?.city?.district?.state?.id,
                },
                district: {
                  label: responseData?.city?.district?.name,
                  value: responseData?.city?.district?.id,
                },
                city: {
                  label: responseData?.city?.name,
                  value: responseData?.city?.id,
                },
                rtoRegion: {
                  label: responseData?.rtoRegion?.keyName,
                  value: responseData?.rtoRegion?.id,
                },
                rtoZone: {
                  label: responseData?.rtoZone?.keyName,
                  value: responseData?.rtoZone?.id,
                },
                isActive: responseData?.isActive,

                nameStatus: responseData?.name ? "success" : "unchecked",
                displayNameStatus: responseData?.displayName
                  ? "success"
                  : "unchecked",
                rtoCodeStatus: responseData?.rtocode ? "success" : "unchecked",
                stateStatus: responseData?.city?.district?.state?.id
                  ? "success"
                  : "unchecked",
                districtStatus: responseData?.city?.district?.id
                  ? "success"
                  : "unchecked",
                cityStatus: responseData?.city?.id ? "success" : "unchecked",
                rtoRegionStatus: responseData?.rtoRegion?.id
                  ? "success"
                  : "unchecked",
                rtoZoneStatus: responseData?.city?.id ? "success" : "unchecked",
              }));
            }
          );
        } catch(error){
          console.error("Error fetching data",error)
          showSnackbar(error?.response?.data?.message || "Network Error", "error");
        }finally {
          setCircleLoading(false);
        }
      }
    };

    fetchData();
  }, [params.id]);

  const handleUpdateRTO = async (rtoData) => {
    const payload = {
      name: rtoData?.name,
      rtoCode: rtoData?.rtoCode,
      cityId: rtoData?.city?.value,
      rtoZoneId: rtoData?.rtoZone?.value,
      rtoRegionId: rtoData?.rtoRegion?.value,
      isActive: rtoData?.isActive,
    };
    try {
      const response = await putData(
        `/reference/motor/rto/${paramId}`,
        payload
      );
      if(response?.success){
        navigate("/motor-master/motor-RTO");
        showSnackbar(response?.message || "Updated Successfully","success");
      }else{
        showSnackbar(response?.message || "Error Updating","error");
      }
    } catch (error) {
      console.error("Error fetching data",error)
      showSnackbar(error?.response?.data?.message, "error");
    }finally{
      setCircleLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton onClick={() => navigate("/motor-master/motor-RTO")}>
                  <ArrowBack />
                </IconButton>
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Edit Motor RTO details
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    Update Motor RTO details here.
                  </MaterialTypography>
                </Stack>
              </Stack>
            </Stack>
          }
        />
        <Box>
          <MotorRTOForm onsubmit={handleUpdateRTO} editRTOData={rtoData} />
        </Box>
      </Card>
    </DashboardLayout>
  );
};

export default EditMotorRTO;
